export const inputStyles = {
    minHeight: '300px',
    width: '100vw',
    resize: 'vertical'
};
